/**
 * @module tree/after
 */

/**
 * @typedef {String|Number|DocumentFragment|Element|Text} Content
 */

import append from './append.js'
import before from './before.js'

/**
 * Adds some contents to a node, after the provided target
 * @param {Document|DocumentFragment|Element} target
 * @param {...Content} contents
 */
export default (
  target,
  ...contents
) => {
  const { nextSibling, parentNode } = target

  if (nextSibling) {
    before(nextSibling, ...contents)
  } else {
    append(parentNode, ...contents)
  }
}
